import { HeroInt } from "interfaces";
import styles from "./Hero.module.scss";
import { heroHome, heroHomePlaceholder } from "assets/images";
import { useEffect } from "react";

const Hero = ({ title, content, bg, paused, home }: HeroInt) => {
  const videoEl = document.getElementById("heroVideo") as HTMLVideoElement;
  useEffect(() => {
    if (videoEl) {
      paused ? videoEl.pause() : videoEl.play();
    }
  }, [videoEl, paused]);
  return (
    <section className={styles.hero}>
      <h1 className={styles.title}>{title}</h1>
      <h4 className={styles.content}>{content}</h4>
      <div className={styles["bg-img__" + bg]} />
      {home && (
        <>
          <video
            id="heroVideo"
            src={heroHome}
            poster={heroHomePlaceholder}
            width={1920}
            height={1080}
            autoPlay
            playsInline
            muted
            loop
          />
          {home}
        </>
      )}
    </section>
  );
};

export default Hero;
